import React, { forwardRef } from 'react';
import "./manageKPIReview.css"
import ManageKPIReviewHeading from "../../../../components/manageKPIReview/manageKPIReviewHeading/ManageKPIReviewHeading";
import ManageKPIReviewConfig from '../../../../components/manageKPIReview/manageKPIReviewConfig/ManageKPIReviewConfig';
import "../../mandatoryConfigs/mandatoryConfigCommon.css"

const ManageKPIReview= forwardRef((props,ref) => {
  const [triggerReset, setTriggerReset] = React.useState(0);
  const handleReset = () => {
    setTriggerReset(triggerReset + 1);
  }
  return (
    <div className='config-container-left '>
      {/* <ManageKPIReviewHeading
        handleReset = {handleReset}
      /> */}
      <ManageKPIReviewConfig
        triggerReset = {triggerReset}
        inputLengthValidation = {{
          max:25,
          min:3
        }}
        handleReset={handleReset}
        ref={ref}
      />
    </div>
  );
})


export default ManageKPIReview;
